<template>
  <v-app>
    <v-app-bar
      app
      color="#466365"
      dark
      clipped-left
    >
      <div class="d-flex align-center">
        <h1>Store Admin</h1>

      </div>

      <v-spacer></v-spacer>

      <v-btn v-show="isLogout"
        text @click="logout"
      >
        <span class="mr-2">Logout</span>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
    
    

    <v-main>

     <v-navigation-drawer
    color='#f5f5f5'
          v-model='isNavDrawer'
          app
          clipped
          left
      >
      
          <v-list class='mt-10' flat>
            <v-list-item-group v-model="menuItem" color="primary">
              <v-list-item
              v-for="item in menuItems"
              :key="item.title"
              v-show="item.visible"
              :to="item.link"
              link
              >
              <v-list-item-icon >
                  <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
    </v-navigation-drawer>
      
       <router-view @showLogout='showLogout' @showNavDrawer='showNavDrawer'></router-view>
    </v-main>
  </v-app>
</template>

<script>
/*global myBaseURL*/

import axios from 'axios';

// import HelloWorld from './components/HelloWorld';
// import Signup from '@/components/Signup'
// import Login from '@/components/Login'

export default {
  name: 'App',

  components: {
    // HelloWorld,
    // Signup,
    // Login
  },

  data: () => ({
    isLogout : false,
    isNavDrawer:false,
    menuItem:1,
    menuItems: [
          { title: 'Dashboard', icon: 'mdi-view-dashboard', visible:true,link:{name:'Dashboard'}},
          { title: 'Catalogue', icon: 'mdi-book-open-page-variant', visible:true, link:{name:'Catalogue'}},
          { title: 'Orders', icon: 'mdi-text-box-outline', visible:true,link:{name:'Orders'}},
          { title: 'Customers', icon: 'mdi-account-box', visible:true,link:{name:'Customers'}},
          { title: 'Settings', icon: 'mdi-cog-outline', visible:true,link:{name:'Settings'}},
        ],
  }),
  created() {
  
    var that = this;
    axios.request({
        url: '/checkMerchantToken',
        method: 'GET',
        baseURL: myBaseURL,
        headers: {
            'Authorization': 'Bearer '+ window.localStorage.access_token
        }
    }).then(response => {
        console.log(response.data);
        if(response.data.token)
        {
          that.isLogout = true;
          // that.isNavDrawer = true;
        }
        else
        {
          that.isLogout = false;
          that.isNavDrawer = false;
          
        }
    }).catch(e => {
        console.log(e);
        console.log('Fail Data')
        that.isLogout = false;
        that.isNavDrawer = false;

    });
  },
  methods: ({
    showLogout(myvar){
      this.isLogout=myvar;
      
    },
    showNavDrawer(myvar)
    {
      console.log('Nav Drawer: '+myvar)
      this.isNavDrawer=myvar;
    },
    logout(){
      var that = this;
      axios.request({
          url: '/logout/access',
          method: 'POST',
          baseURL: myBaseURL,
          headers: {
              'Authorization': 'Bearer '+ window.localStorage.access_token
          }
      }).then(response => {
          console.log(response.data);
          that.isLogout = false;
          that.isNavDrawer=false;
          localStorage.setItem('access_token', '');
          that.$router.push({ path: '/' });
          console.log('Submit Success');
      }).catch(e => {
          console.log(e);
          console.log('Submit Fail');
      });
    }
  })
};
</script>
